import React from 'react';
import { Button } from '../../../../../../../ui-kit';






const FooterButtons = (props) => {
  const { onClickHelpLink, openLiveChatModal } = props;
  return (
    <>
      <Button type="TERTIARY" onClick={onClickHelpLink}>Learn More</Button>
      <Button
        id="topup-credits-v2"
        className="topup-modal__button"
        type="PRIMARY"
        onClick={openLiveChatModal}>

        Live Chat Now
      </Button>
    </>);

};

export default FooterButtons;